import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { carouselSliceActions } from "../../../../store/carouselSlice";
import { CardTypes } from "../../../../helpers/generalTypes";
import { delay } from "../../../../helpers/helperfunctions";

const AdaptiveSingleButtonCardRenderer = (props) => {
  const reduxDispatch = useDispatch();
  const vaState = useSelector((state) => state.vaStateStore.vaState);
  const activeStatus = useSelector(
    (state) => state.activityStore.activeStauses[props.activityId]
  );
  const [cardInfo, setCardInfo] = useState(undefined);
  useEffect(() => {
    const actions = props.cardToRender?.props?.attachment?.content?.actions;
    if (actions && actions.length > 0) {
      const commandText = actions[0].title;
      props.cardToRender.props.attachment.content.images?.map((image) => {
        image.alt = commandText;
      });
      if (!props.cardToRender.props.attachment.content.body) {
        props.cardToRender.props.attachment.content.body = [];
      }
      props.cardToRender.props.attachment.content.body.push({
        type: "TextBlock",
        text: commandText,
        horizontalAlignment: "Center",
        wrap: true,
      });
      props.cardToRender.props.attachment.content.text = commandText;
      const divId = uuidv4();
      setCardInfo({
        divId: divId,
        theme: vaState?.theme,
        cardToRender: props.cardToRender,
        className: `${vaState?.theme}-single-button-card ${vaState?.theme}-single-button-card-enabled`,
      });
    }
  }, []);
  useEffect(() => {
    if (activeStatus !== undefined) {
      if (activeStatus === false) {
        setCardInfo((prev) => ({
          ...prev,
          className: `${vaState?.theme}-single-button-card ${vaState?.theme}-single-button-card-disabled`,
        }));
      }
    }
  }, [activeStatus]);
  useEffect(() => {
    if (cardInfo) {
      setTimeout(async () => {
        let separators = document
          .getElementById(cardInfo.divId)
          ?.querySelectorAll(".ac-horizontal-separator");
        if (!separators) {
          await delay(200);
          separators = document
            .getElementById(cardInfo.divId)
            ?.querySelectorAll(".ac-horizontal-separator");
        }
        if (separators && separators.length === 2) {
          separators[1].classList.add("hide-div");
        }
        const actionSetParent = document
          .getElementById(cardInfo.divId)
          ?.querySelector(".ac-actionSet")
          ?.closest(".ac-container > div");
        if (actionSetParent) {
          actionSetParent.classList.add("hide-div");
        }
        const imageDiv = document
          .getElementById(cardInfo.divId)
          ?.querySelector(".ac-image")
          ?.closest("div");
        if (imageDiv) {
          imageDiv.classList.add("image-div");
        }
        if (cardInfo.cardToRender?.props?.attachment?.carouselId) {
          reduxDispatch(
            carouselSliceActions.addCarouselAttachment({
              attachmentId: cardInfo.divId,
              cardType: CardTypes.SingleButtonCard,
              carouselId: cardInfo.cardToRender.props.attachment.carouselId,
            })
          );
        }
      }, 0);
    }
  }, [cardInfo]);
  const handleAdaptiveCardClick = (e) => {
    if (activeStatus) {
      const btn = document
        .getElementById(cardInfo.divId)
        ?.querySelector(".ac-actionSet>button");
      if (btn) {
        btn.click();
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <>
      {cardInfo && (
        <div
          id={cardInfo.divId}
          className={cardInfo.className}
          tabIndex="0"
          onClick={(e) => handleAdaptiveCardClick(e)}
        >
          {cardInfo.cardToRender}
        </div>
      )}
    </>
  );
};

export default AdaptiveSingleButtonCardRenderer;
